export const ERROR_RESET_CONFIRMATION_NEEDED = 1020;
export const ERROR_VAULT_SOLE_OWNER = 723;

export class ApiError extends Error {
    constructor(message, id) {
        super(message);
        this.name = 'ApiError';
        this.id = id;
    }
}
